import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Sun } from "lucide-react";
import { ClienteView } from "@/components/cliente/ClienteView";
import { ConsensoGate } from "@/components/cliente/ConsensoGate";
import { BrandBar } from "@/components/cliente/BrandBar";
import { clienteSource, pubApi, SESS_KEY, clienteFont } from "@/components/cliente/clienteApi";

function Pin({ token, onOk }) {
  const [info, setInfo] = useState(null);
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { pubApi.get(`/cliente/${token}/info`).then((r) => setInfo(r.data)).catch((e) => setInfo({ errore: e.response?.data?.detail || "Link non valido" })); }, [token]);
  const go = async () => {
    setBusy(true); setErr("");
    try { const r = await pubApi.post(`/cliente/${token}/accesso`, { pin }); localStorage.setItem(SESS_KEY(token), r.data.sessione); onOk(r.data.sessione); }
    catch (e) { setErr(e.response?.data?.detail || "Accesso non riuscito"); }
    setBusy(false);
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-sky-50 to-white p-6" style={{ fontFamily: clienteFont() }} data-testid="cliente-pin-page">
      <div className="w-full max-w-sm rounded-3xl bg-white p-6 text-center shadow-xl ring-1 ring-slate-100">
        {info && !info.errore ? <BrandBar logo={info.logo} nome={info.installatore} compact />
          : <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-100"><Sun className="h-8 w-8 text-amber-500" /></span>}
        {!info ? <Loader2 className="mx-auto mt-6 h-6 w-6 animate-spin text-sky-500" /> : info.errore ? <p className="mt-5 text-slate-600" data-testid="cliente-pin-link-error">{info.errore}</p> : <>
          <h1 className="mt-4 text-xl font-extrabold text-slate-800" data-testid="cliente-pin-nome">{info.nome}</h1>
          <p className="mt-1 text-sm text-slate-500">Inserisci il PIN che ti ha dato {info.installatore || "il tuo installatore"}</p>
          <input value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} onKeyDown={(e) => e.key === "Enter" && pin.length === 6 && go()}
            inputMode="numeric" autoFocus placeholder="••••••" data-testid="cliente-pin-input"
            className="mt-5 h-14 w-full rounded-2xl bg-slate-100 text-center font-mono text-2xl tracking-[0.5em] text-slate-800 outline-none focus:ring-2 focus:ring-sky-300" />
          {err && <p className="mt-2 text-sm text-red-500" data-testid="cliente-pin-error">{err}</p>}
          <button type="button" onClick={go} disabled={pin.length !== 6 || busy} data-testid="cliente-pin-submit"
            className="mt-4 h-12 w-full rounded-2xl bg-sky-500 font-bold text-white transition-colors hover:bg-sky-600 disabled:opacity-40">{busy ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : "Entra"}</button>
        </>}
      </div>
    </div>
  );
}

export default function ClientePortal() {
  const { token } = useParams();
  const [sess, setSess] = useState(() => localStorage.getItem(SESS_KEY(token)));
  const [consenso, setConsenso] = useState(null); // null=da verificare, true=ok, false=richiesto
  const src = useMemo(() => sess && clienteSource(sess), [sess]);

  useEffect(() => {
    if (!src) { setConsenso(null); return; }
    let vivo = true;
    src.consensoStato()
      .then((r) => { if (vivo) setConsenso(!r.richiesto); })
      .catch((e) => { if (!vivo) return; if (e.response?.status === 401) { localStorage.removeItem(SESS_KEY(token)); setSess(null); } else setConsenso(false); });
    return () => { vivo = false; };
  }, [src, token]);

  if (!sess) return <Pin token={token} onOk={(s) => { setConsenso(null); setSess(s); }} />;
  if (consenso === null) return <div className="flex min-h-screen items-center justify-center bg-sky-50"><Loader2 className="h-8 w-8 animate-spin text-sky-500" /></div>;
  if (consenso === false) return <ConsensoGate src={src} onDone={() => setConsenso(true)} />;
  return <div className="min-h-screen bg-slate-50"><ClienteView key={sess} src={src} /></div>;
}
